import Aura from '@primeuix/themes/aura'
import {definePreset} from '@primeuix/themes'

//Create preset
const preset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{neutral.50}',
      100: '{neutral.100}',
      200: '{neutral.200}',
      300: '{neutral.300}',
      400: '{neutral.400}',
      500: '{neutral.500}',
      600: '{neutral.600}',
      700: '{neutral.700}',
      800: '{neutral.800}',
      900: '{neutral.900}',
      950: '{neutral.950}',
    },
    colorScheme: {
      light: {
        surface: {
          50: '{slate.100}', //More contrast for hover over buttons
          100: '{slate.200}', //More contrast for focussed elements in dropdown
        },
      },
      dark: {
        surface: {
          800: '{slate.700}', //More contrast for focussed elements in dropdown
        },
      },
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{surface.600}',
      offset: '-1px',
    },
  },
  components: {
    avatar: {
      root: {
        width: '2.25rem',
        height: '2.25rem',
      },
      lg: {
        width: '3rem',
        height: '3rem',
      },
      xl: {
        width: '4rem',
        height: '4rem',
      },
    },
  },
})

//PrimeVue config
export const primeVueConfig = {
  locale: {
    am: 'AM',
    pm: 'PM',
    firstDayOfWeek: 0,
  },
  theme: {
    preset,
    options: {
      darkModeSelector: '.app-theme-dark', //CSS selector for dark mode (only class name seems to work)
      cssLayer: {
        name: 'primevue', //The name of PrimeVue's CSS layer
        order: 'reset, elements, primevue, primevue-overrides', // Define the layer order
      },
    },
  },
}
